import { BaseService } from '../../../core/services/base.service';
import { ReleaseWhatsNewStatus } from './releaseWhatsNew.types';

const DISMISS_MAX_ATTEMPTS = 3;
const DISMISS_RETRY_DELAY_MS = 400;

function delay(ms: number): Promise<void> {
  return new Promise((resolve) => {
    setTimeout(resolve, ms);
  });
}

export class ReleaseWhatsNewService {
  static async fetchStatus(): Promise<ReleaseWhatsNewStatus> {
    const url = BaseService.BuildUrl('/public/release-whats-new/status');
    const response = await fetch(url);

    if (!response.ok) {
      throw new Error(`Release status failed: ${response.status}`);
    }

    return (await response.json()) as ReleaseWhatsNewStatus;
  }

  static async dismiss(): Promise<void> {
    const url = BaseService.BuildUrl('/public/release-whats-new/dismiss');
    let lastError: Error | undefined;

    for (let attempt = 1; attempt <= DISMISS_MAX_ATTEMPTS; attempt += 1) {
      try {
        const response = await fetch(url, { method: 'POST' });
        if (response.ok || response.status === 204) {
          return;
        }
        lastError = new Error(`Release dismiss failed: ${response.status}`);
      } catch (error) {
        lastError =
          error instanceof Error ? error : new Error('Release dismiss failed');
      }

      if (attempt < DISMISS_MAX_ATTEMPTS) {
        await delay(DISMISS_RETRY_DELAY_MS * attempt);
      }
    }

    throw lastError ?? new Error('Release dismiss failed');
  }
}
